
import { defineComponent, reactive, toRefs } from 'vue'
import { useStore } from 'vuex'
import { Toast } from 'vant'
import request from '@/utils/hbRequest.js'
export default defineComponent({
  name: 'QrCode',
  setup() {
    const store = useStore()
    const state = reactive({
      list: [],
      userId: ''
    })

    const getQrList = async () => {
      const id = store.state.userId
      state.userId = id
      const res = await request.get(`/spread/salesman/${id}/QRCode/list`)
      if (res.code !== 0) {
        return Toast(res.message)
      }
      state.list = res.data
    }
    getQrList()

    const downloadQrcode = (url) => {
      // let alink = document.createElement('a')
      // alink.href = url
      // alink.download = url
      // alink.click()
      Toast('长按二维码保存图片到手机')
    }

    return {
      ...toRefs(state),
      downloadQrcode
    }
  }
})
